"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Footer = require("./Footer");

var _default = _Footer.Footer;
exports["default"] = _default;